import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Center,
  Select,
  Pagination,
  Checkbox,
  Tabs,
  Badge,
  Group,
  Button,
  Paper,
  Skeleton,
  Grid,
  TextInput,
  Textarea,
  Breadcrumbs,
  Anchor,
} from "@mantine/core";
import {
  IconSearch,
  IconSelector,
  IconChevronDown,
  IconChevronUp,
  IconTrash,
  IconChecklist,
  IconUserPlus,
  IconEye,
  IconTruck,
  IconPercentage,
} from "@tabler/icons-react";
import classes from "./DealerRebate.module.css";
// import DeleteStaff from "./DeleteStaff";
import { RowDataDealerRebate } from "./types";
import { props } from "./props";
import { CustomTable } from "../Table/CustomTable";
// import { dealer } from "../types/RowDataTypes";
import { dealerRebate } from "../types/RowDataTypes";
import { useFetchRowData } from "../hooks/useFetchRowData";
import { SearchBar } from "../SearchBar/SearchBar";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery, useMutation } from "react-query";
import {
  showErrorAlert,
  showEditWarning,
  showSuccessAlert,
} from "../../helper/alerts";
import Header from "../static/Header";
// import VerifyDealer from "./VerifyDealer";
// import getOrderTable from "../../DataDisplay/DataDisplayTable/OrderTable";
// import getDealerTable from "../../DataDisplay/DataDisplayTable/DealerTable";
import getDealerRebateTable from "../../DataDisplay/DataDisplayTable/DealerRebateTable";
import CreateRebateModal from "./CreateRebateModal";
import DeleteModal from "./DeleteModal";

import { formatYYYY_MM_DD } from "../../helper/DateTime";

enum ColumnHeaderToFilterPair {
    STARTDATE = "Start Date",
    ENDDATE = "End Date",
    PERCENTAGE = "Percentage",
    AMOUNT = "Amount (RM)",
    CREATEDAT = "Created At",
    ISISSUED = "Issued",
    ACTION = "Action",
}

const colFilter = ColumnHeaderToFilterPair;
const colFilters: { [key in ColumnHeaderToFilterPair]: string } = {
  [colFilter.STARTDATE]: "startDate",
  [colFilter.ENDDATE]: "endDate",
  [colFilter.PERCENTAGE]: "percentage",
  [colFilter.AMOUNT]: "amount",
  [colFilter.CREATEDAT]: "createdAt",
  [colFilter.ISISSUED]: "",
  [colFilter.ACTION]: "",
};

function Th({ children, sortable, reversed, sorted, onSort }: props) {
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;

  let allowedSorts;

  allowedSorts = [
    // colFilter.COMPANY.toString().toLowerCase(),
    colFilter.STARTDATE.toString().toLowerCase(),
    colFilter.ENDDATE.toString().toLowerCase(),
    colFilter.PERCENTAGE.toString().toLowerCase(),
    colFilter.AMOUNT.toString().toLowerCase(),
    // colFilter.CONTACTNO.toString().toLowerCase(),
    // colFilter.EMAIL.toString().toLowerCase(),
    // colFilter.DOB.toString().toLowerCase(),
];
  const isCurrent =
    window.location.href.split("/")[5] === "pending-verification" ? true : false;
//   console.log("the children");
//   console.log(children);
//   console.log(allowedSorts);
//   console.log(allowedSorts.includes(children!!.toString().toLowerCase()));

  return children!! === "action" && !isCurrent ? (
    <></>
  ) : (
    <Table.Th className={`${classes.th} ${sortable ? classes.sortable : ""}`}>
      {allowedSorts.includes(children!!.toString().toLowerCase()) ? (
        <UnstyledButton onClick={onSort} className={classes.control}>
          <div className={classes.sortableHeader}>
            <Text fw={500} fz="sm">
              {children}
            </Text>
            <Center className={classes.icon}>
              <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
            </Center>
          </div>
        </UnstyledButton>
      ) : (
        <Text fw={500} fz="sm">
          {children}
        </Text>
      )}
    </Table.Th>
  );
}

const initialData: RowDataDealerRebate[] = [
  {
    id: 0,
    uid: "",
    startDate: "",
    endDate: "",
    percentage: 0,
    amount: null,
    createdAt: "",
    isIssued: false,
  },
];

export function DealerRebate() {
  const axiosPrivate = useAxiosPrivate();
  let { uid } = useParams();
  const [search, setSearch] = useState<string>("");
  const [sortedData, setSortedData] = useState(initialData);
  const [sortBy, setSortBy] = useState<keyof RowDataDealerRebate | null>(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [isAddRebateFormVisible, setAddRebateFormVisible] = useState(false);

  const [isDeleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const [selectedRowToDelete, setSelectedRowToDelete] =
    useState<RowDataDealerRebate | null>(null);

  const handleAddVouchers = () => {
    setAddRebateFormVisible(true);
  };

  const [tableStateChanged, setTableStateChanged] = useState(0);
  const changeTableState = () => {
    setTableStateChanged(Math.random() * Math.random());
  };

  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const resetPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(1);
      return true;
    }
    return false;
  };

    const getDealerQuery = useQuery(
        "getDealer",
        async ({ signal }) => (await axiosPrivate.post("/api/admin/dealer/read-by-uid", { uid } ,{ signal })).data.dealer,
        {
            initialData: null,
            cacheTime: 0,
            onSuccess: (res) => {
                console.log(res)
            },
            onError: () => {

            }
        }
    );

    const addRebateMutation = useMutation(
        (data: any) => axiosPrivate.post("/api/admin/dealer-rebate/add", data, {headers: {'Content-Type': 'multipart/form-data'}}),
        {
            onSuccess: (res: any) => {
                setAddRebateFormVisible(false);
                changeTableState();
                showSuccessAlert("Rebate Successfully Created");
            },
            onError:(err: any) => {
                setAddRebateFormVisible(false);
                let errMsg = err?.response?.data?.message
                showErrorAlert(errMsg ? errMsg : 'An error has occured');
            }
        }
    );

    const deleteRebateMutation = useMutation(
        (data: any) => axiosPrivate.post("/api/admin/dealer-rebate/delete", data, {headers: {'Content-Type': 'multipart/form-data'}}),
        {
            onSuccess: (res: any) => {
                setDeleteConfirmationOpen(false);
                changeTableState();
                showSuccessAlert("Rebate successfully removed");
                setSelectedRowToDelete(null);
            },
            onError:(err: any) => {
                setDeleteConfirmationOpen(false);
                let errMsg = err?.response?.data?.message
                showErrorAlert(errMsg ? errMsg : 'An error has occured');
                setSelectedRowToDelete(null);
            }
        }
    );

  const checkboxesFilter: JSX.Element[] = [];

  //Set allowed search filter checkbox to be shown
  const allowedFilters = [
    colFilters[colFilter.STARTDATE],
    colFilters[colFilter.ENDDATE],
    colFilters[colFilter.PERCENTAGE],
  ];

  for (const [key, value] of Object.entries(colFilters)) {
    if (allowedFilters.includes(value)) {
      const checkboxFilter: JSX.Element = (
        <Checkbox value={value} label={key} />
      );
      checkboxesFilter.push(checkboxFilter);
    }
  }

  const [showFilterOptions, setShowFilterOptions] = useState(false);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setSearch(input);
  };

  const location = useLocation();
  const fetchedData = useFetchRowData(
    itemsPerPage,
    currentPage,
    search,
    selectedFilters,
    tableStateChanged,
    sortBy ?? "createdAt",
    reverseSortDirection ? "DESC" : "ASC",
    dealerRebate,
    getDealerRebateTable().create(),
    {
      current: uid,
    //   current: "unverified",
    },
  );

  const itemsOnPage = useRef(0);
  const totalRows = fetchedData.totalRows;
  const rowData: RowDataDealerRebate[] | null = fetchedData.data as RowDataDealerRebate[];
  const isLoading: boolean = fetchedData.isLoading;
  const [RowDataDealer, setRowDataDealer] = useState<RowDataDealerRebate[] | null>(null);

  useEffect(() => {
    setRowDataDealer(rowData);
    itemsOnPage.current = fetchedData.itemsOnPage;
  }, [rowData]);

  const [selectedRow, setSelectedRow] = useState<RowDataDealerRebate | null>(null);
  const [isEditMode, setEditMode] = useState(false);
  const handleEdit = (row: RowDataDealerRebate) => {
    setSelectedRow(row);

    // Check if the current page is "pass", then show the edit warning
    if (location.pathname.split("/")[2] === "verified") {
      showEditWarning("Are you sure you want to edit this dealer?", setEditMode);
    } else {
      // If the page is not "pass", directly setEditMode to true
      setEditMode(true);
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (value: number) => {
    setCurrentPage(1);
    setItemsPerPage(value);
  };

  const isCurrent =
    location.pathname.split("/")[2] === "pending-verification" ? true : false;
  const rowsToMap = RowDataDealer ?? [];
  const rows = rowsToMap.map((row, index) => (
    <Table.Tr key={index}>
      <Table.Td>{startIndex + index + 1}</Table.Td>
      <Table.Td>{formatYYYY_MM_DD(row.startDate)}</Table.Td>
      <Table.Td>{formatYYYY_MM_DD(row.endDate)}</Table.Td>
      <Table.Td><Badge variant="outline" color="dark">{row.percentage}%</Badge></Table.Td>
      <Table.Td>{row.amount}</Table.Td>
      <Table.Td>{formatYYYY_MM_DD(row.createdAt)}</Table.Td>
        <Table.Td>
            {row.isIssued ? 
                <Badge variant="outline" color="green">True</Badge>
                :
                <Badge variant="outline" color="red">False</Badge>
            }
        </Table.Td>
      <Table.Td className={classes.actionButtons}>
        {row.isIssued ?
        <>
            <button className={classes.disabledbutton}>
                <IconChecklist /> Delete
            </button>
        </>
        :
        <>
            <button
                onClick={() => handleDelete(row)} className={classes.trashbutton}
            >
                <IconTrash /> Delete
            </button>
        </>
        }
        
      </Table.Td>
    </Table.Tr>
  ));

  const handleSelectPage = (selectedPage: number) => {
    if (selectedPage != currentPage) setCurrentPage(selectedPage);
  };

  const nav = useNavigate();

  const handleTabChange = (val: string | null) => {
    val = val ?? "pending-verification";
    nav(`/dealer/${val}`);
    changeTableState();
  };

  const handleSorting = (val: any) => {
    setReverseSortDirection(!reverseSortDirection);
    setSortBy(val);
    changeTableState();
    // console.log("sorting");
    // console.log(val);
    // console.log(reverseSortDirection);
  };

    const handleAddRebate = (newData: RowDataDealerRebate) => {
        addRebateMutation.mutate({
            uid: uid,
            startDate: newData.startDate,
            endDate: newData.endDate,
            percentage: newData.percentage,
        })
    };

    const handleDelete = (row: RowDataDealerRebate) => {
        setSelectedRowToDelete(row);
        setDeleteConfirmationOpen(true);
    };

    const handleDeleteConfirmed = () => {
        deleteRebateMutation.mutate({
            uid: selectedRowToDelete?.uid,
            id: selectedRowToDelete?.id,
        })
    };

    const handleDeleteCancelled = () => {
        setDeleteConfirmationOpen(false);
        setSelectedRowToDelete(null);
    };

  return (
    <div className={classes.orderContainer}>
      <ScrollArea className={classes.parentContainer}>
        <Header
          title={
            <div>
              <p>Dealer</p>
            </div>
          }
        />
        <Breadcrumbs mx={20} my={'sm'}>
            <Anchor component={Link} to={'/dealer/verified'}>
                Dealer
            </Anchor>
            <Anchor>
                Manage Rebate
            </Anchor>
        </Breadcrumbs>
        <Paper mx={20} my={'sm'}>
            <Skeleton visible={getDealerQuery.isFetching || getDealerQuery.isError} animate={!getDealerQuery.isError}>
                <Paper style={{backgroundColor: '#F8F9FA'}} p={'sm'}>
                    <Text fw={500}>Dealer Info ({getDealerQuery.data?.company ? 'Company' : 'Individual'})</Text>
                    <Grid >
                        <Grid.Col span={{ base: 12, md: 4}}>
                            <TextInput
                                label="Full Name"
                                readOnly
                                size="xs"
                                value={getDealerQuery.data?.fullname}
                            />
                            <TextInput
                                label="Phone Number"
                                readOnly
                                size="xs"
                                value={getDealerQuery.data?.phone_number}
                            />
                            <TextInput
                                label="Email"
                                readOnly
                                size="xs"
                                value={getDealerQuery.data?.email ? getDealerQuery.data?.email : '-'}
                            />
                            <TextInput
                                label="Full Name (NRIC)"
                                readOnly
                                size="xs"
                                value={getDealerQuery.data?.nric_fullname}
                            />
                            <TextInput
                                label="NRIC"
                                readOnly
                                size="xs"
                                value={getDealerQuery.data?.nric}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, md: 4}}>
                            {getDealerQuery.data?.company ?
                            <>
                            <TextInput
                                label="Company"
                                readOnly
                                size="xs"
                                value={getDealerQuery.data?.company}
                            />
                            <TextInput
                                label="TIN"
                                readOnly
                                size="xs"
                                value={getDealerQuery.data?.tin}
                            />
                            <Textarea
                                label="Address"
                                size="xs"
                                readOnly
                                value={`${getDealerQuery.data?.address_line_1}, ${getDealerQuery.data?.address_line_2 ? getDealerQuery.data?.address_line_2 + ',' : ''} ${getDealerQuery.data?.postal}, ${getDealerQuery.data?.city}, ${getDealerQuery.data?.state}` }
                            />
                            <TextInput
                                label="Company Contact"
                                readOnly
                                size="xs"
                                value={getDealerQuery.data?.business_phone_number}
                            />
                            <TextInput
                                label="SST Registration Number"
                                readOnly
                                size="xs"
                                value={getDealerQuery.data?.sst_registration_number ? getDealerQuery.data?.sst_registration_number : '-'}
                            />
                            </>
                            : null
                            }
                            
                        </Grid.Col>
                    </Grid>
                </Paper>
            </Skeleton>
        </Paper>
        <div className={classes.searchBarContainer}>
          <SearchBar
            isLoading={isLoading}
            resetPage={resetPage}
            changeTableState={changeTableState}
            search={search}
            handleSearch={handleSearch}
            setShowFilterOptions={setShowFilterOptions}
            showFilterOptions={showFilterOptions}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            checkboxesFilter={checkboxesFilter}
          />
          <div className={classes.addButtonContainer}>
                        <Button
                        disabled={getDealerQuery.isFetching || getDealerQuery.isError}
                        onClick={() => setAddRebateFormVisible(true)}
                        className={classes.addVoucherButton}
                        >
                        <IconPercentage style={{ marginRight: "5px" }} /> Create Rebate
                        </Button>
                    </div>
        </div>

          <ScrollArea
            w={
              window.innerWidth -
              document.getElementById("nav-bar")!!.getBoundingClientRect().width
            }
          >
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />

          </ScrollArea>

        <div className={classes.footerContainer}>
          <div className={classes.resultCount}>
            <Text>
              {`Showing `}
              <span style={{ fontWeight: "bold" }}>{startIndex + 1}</span>
              {`-`}
              <span style={{ fontWeight: "bold" }}>
                {Math.min(currentPage * itemsPerPage, totalRows)}
              </span>
              {` of `}
              <span style={{ fontWeight: "bold" }}>{totalRows}</span>
              {` results `}
            </Text>
          </div>

          <div className={classes.rightContainer}>
            <div className={classes.rowsPerPageSelector}>
              <Select
                placeholder="Rows per page"
                data={["10", "20", "50"]}
                value={itemsPerPage.toString()}
                onChange={(value) =>
                  handleRowsPerPageChange(parseInt(value as string, 10))
                }
              />
            </div>

            <div className={classes.paginationSelector}>
              <Pagination
                color="blueviolet"
                value={currentPage}
                total={Math.ceil(totalRows / itemsPerPage)}
                onNextPage={() => handlePageChange(currentPage + 1)}
                onPreviousPage={() => handlePageChange(currentPage - 1)}
                onChange={(value: number) => handleSelectPage(value)}
              />
            </div>
          </div>
        </div>

        <CreateRebateModal
            isVisible={isAddRebateFormVisible}
            onClose={() => setAddRebateFormVisible(false)}
            onAddRebate={(newData) => handleAddRebate(newData)}
        />

        <DeleteModal
          isOpen={isDeleteConfirmationOpen}
          onClose={handleDeleteCancelled}
          onConfirm={handleDeleteConfirmed}
        />

        {/* {isEditMode && (
          <VerifyDealer
            isOpen={isEditMode}
            onClose={() => setEditMode(false)}
            onSaveChanges={(editedData, action, remark) =>
                handleVerifyDealer(editedData, selectedRow, action, remark)
            }
            initialData={selectedRow as RowDataDealer}
          />
        )} */}
      </ScrollArea>
    </div>
  );
}

export default DealerRebate;
